import { lazy } from "react";
import { PATHS } from "@/lib/router";

const NotificationsPage = lazy(() => import("./pages/NotificationsPage"));

export const notificationsRoutes = [
  {
    path: PATHS.NOTIFICATIONS,
    element: <NotificationsPage />,
  },
];
